import { render, staticRenderFns } from "./edit-vendor.vue?vue&type=template&id=2f9e526c&scoped=true"
import script from "./edit-vendor.vue?vue&type=script&lang=js"
export * from "./edit-vendor.vue?vue&type=script&lang=js"
import style0 from "./edit-vendor.vue?vue&type=style&index=0&id=2f9e526c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e526c",
  null
  
)

export default component.exports